export { type Collection, collectionTable } from "#collection-table";
